import type {ComponentPropsWithoutRef} from 'react';
import styles from './radio-button.module.css';

type Props = ComponentPropsWithoutRef<'label'> & {
  readonly inputProps?: ComponentPropsWithoutRef<'input'>;
};

/**
 * スタイルは TestMailButton のデザインに強く依存しているので、再利用しないでください
 */
export function TestMailButtonRadioButton({
  inputProps,
  children,
  ...props
}: Props) {
  return (
    <label {...props} className={styles.label}>
      <span className={styles.inputContainer}>
        <input type='radio' {...inputProps} className={styles.radio} />
      </span>

      {children}
    </label>
  );
}
